import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import * as nodeOps from '../../../api/Tasks/task-node-operations';

const ConnParamRefreshLatencyField = ({ selectedNode, showRefreshLatencyField }) => {
  if (!showRefreshLatencyField) return '';
  return (
    <>
      <Form.Label>Refresh Latency (minutes)</Form.Label>
      <Form.Control
        name="refreshLatency"
        type="number"
        min="1"
        defaultValue={nodeOps.getRefreshLatency(selectedNode).toString()}
        placeholder="Set the refresh interval in minutes"
      />
    </>
  );
};
ConnParamRefreshLatencyField.propTypes = {
  selectedNode: PropTypes.object.isRequired,
  showRefreshLatencyField: PropTypes.bool.isRequired
};

export default ConnParamRefreshLatencyField;
